import * as Events from '@project/shared/utils/events/js/events';

const overlayDataName: string = 'covestro-overlay';
export function IsOverlayDisplayed(): boolean {
    const value = $(window.document.documentElement).data(overlayDataName);
    if (value == undefined || value == null || typeof value !== 'boolean') return false;
    return <boolean>value;
}

export function ShowOverlay(openFunc: () => void, delayInMs: number = 0) {
    if (!IsOverlayDisplayed()) {
        ShowOverlayWithRetry(openFunc, delayInMs);
    } else {
        console.debug(`Detected an open overlay; waiting.`);

        let unsubscribeCloseHandler = Events.onPublicEvent(Events.PublicEvents.overlayClosed, window.document.documentElement, (e, d) => {
            unsubscribeCloseHandler();

            console.debug(`Detected closing of another overlay; registring.`);

            ShowOverlayWithRetry(openFunc, delayInMs);
        });
    }
}

function ShowOverlayWithRetry(openFunc: () => void, delayInMs: number = 0) {
    let unsubscribeOpenHandler: () => void,
        unsubscribeCloseHandler: () => void;

    console.debug(`Registering overlay with ${delayInMs}ms delay.`);

    const timeoutHandle = setTimeout(() => {
        if (unsubscribeOpenHandler != null) unsubscribeOpenHandler();
        if (unsubscribeCloseHandler != null) unsubscribeCloseHandler();

        DoShowOverlay(openFunc);
    }, delayInMs);

    // Abort the timeout in case another overlay opens
    unsubscribeOpenHandler = Events.onPublicEvent(Events.PublicEvents.overlayOpened, window.document.documentElement, (e, d) => {
        unsubscribeOpenHandler();
        unsubscribeOpenHandler = null;

        clearTimeout(timeoutHandle);

        console.debug(`Detected opening of another overlay; aborted.`);

        // And re-register when that overlay gets closed
        unsubscribeCloseHandler = Events.onPublicEvent(Events.PublicEvents.overlayClosed, window.document.documentElement, (e, d) => {
            unsubscribeCloseHandler();
            unsubscribeCloseHandler = null;

            console.debug(`Detected closing of another overlay; re-registring.`);

            ShowOverlayWithRetry(openFunc, delayInMs);
        });
    });
}

function DoShowOverlay(openFunc: () => void) {
    console.debug(`Opening overlay.`);

    Events.triggerPublicEvent(Events.PublicEvents.overlayOpened, null, window.document.documentElement);
    $(window.document.documentElement).data(overlayDataName, true);

    openFunc();

    console.debug(`Opening overlay complete.`)
}

export function CloseOverlay(closeFunc: () => void) {
    console.debug(`Closing overlay.`);

    closeFunc();

    $(window.document.documentElement).data(overlayDataName, false);
    Events.triggerPublicEvent(Events.PublicEvents.overlayClosed, null, window.document.documentElement)

    console.debug(`Closing overlay complete.`);
}